import React, { useEffect, useState } from 'react';
import { Routes, Route, useNavigate, useParams } from 'react-router-dom';
import CreateAdmin from '../components/AdminManagement/CreateAdmin';
import AdminDashboard from '../components/AdminManagement/AdminDashboard';
import api from '../services/Api';
import { BeatLoader } from 'react-spinners';
import { useSelector } from 'react-redux';

const AdminManagement = () => {
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.auth);
  const userId = userData?.sub;

  const handleCreateAdmin = () => {
    navigate('/admin-management/create');
  };

  const handleEditCurrentAdmin = () => {
    if (userId) {
      navigate(`/admin-management/edit/${userId}`);
    } else {
      console.error('No admin ID found in Cookie');
    }
  };

  const handleEditAdmin = adminId => {
    navigate(`/admin-management/edit/${adminId}`);
  };

  const handleDeleteAdmin = async adminId => {
    if (window.confirm('Are you sure you want to delete this administrator?')) {
      try {
        await api.delete(`/admin/${adminId}`);
        window.location.reload();
      } catch (error) {
        console.error('Error deleting admin:', error);
        alert('Failed to delete administrator');
      }
    }
  };

  return (
    <Routes>
      <Route
        path="/"
        element={
          <AdminDashboard
            onCreateAdmin={handleCreateAdmin}
            onEditProfile={handleEditCurrentAdmin}
            onEditAdmin={handleEditAdmin}
            onDeleteAdmin={handleDeleteAdmin}
          />
        }
      />
      <Route path="create" element={<CreateAdmin editMode={false} />} />
      <Route path="edit/:adminId" element={<AdminEditWrapper />} />
    </Routes>
  );
};

const AdminEditWrapper = () => {
  const [adminData, setAdminData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { adminId } = useParams();

  useEffect(() => {
    const fetchAdminData = async () => {
      try {
        const response = await api.get(`/admin/${adminId}`);

        if (response.data) {
          const adminInfo = response.data;

          if (!adminInfo._id && adminInfo.id) {
            adminInfo._id = adminInfo.id;
          }

          setAdminData(adminInfo);
        } else {
          throw new Error('No admin data returned');
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching admin data:', err);
        setError('Failed to load admin data: ' + (err.response?.data?.message || err.message));
        setLoading(false);
      }
    };

    fetchAdminData();
  }, [adminId]);

  if (loading) {
    return (
      <div className="w-full p-4 pl-64 h-screen bg-[#F4F5F6] flex justify-center items-center">
        <BeatLoader color="#000000" size={15} />
      </div>
    );
  }
  if (error)
    return (
      <div className="w-full p-4 pl-64 h-screen bg-[#F4F5F6] text-center text-red-500">{error}</div>
    );
  if (!adminData)
    return (
      <div className="w-full p-4 pl-64 h-screen bg-[#F4F5F6] text-center">No admin data found</div>
    );

  return <CreateAdmin editMode={true} adminData={adminData} />;
};

export default AdminManagement;
